import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, ConfigStateService } from '@abp/ng.core';
import { CoachService } from '@proxy/application/services/coaches';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const coachProfileCompletionGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const configState = inject(ConfigStateService);
  const coachService = inject(CoachService);

  // If not authenticated, let authGuard handle it
  if (!authService.isAuthenticated) {
    return false;
  }

  const currentUser = configState.getOne('currentUser');

  // If no current user, redirect to login
  if (!currentUser?.id) {
    return false;
  }

  // Check if coach profile is complete by getting coach data
  return coachService.getByUserId(currentUser.id).pipe(
    map(coach => {
      // Check if essential profile fields are completed
      const isProfileComplete = coach &&
        coach.displayName &&
        coach.bio &&
        coach.phone &&
        coach.experienceYears !== undefined &&
        coach.maxStudents !== undefined &&
        coach.bio.length >= 50; // Based on validation in profile completion component

      if (!isProfileComplete) {
        router.navigate(['/coach/profile-completion']);
        return false;
      }

      return true;
    }),
    catchError(error => {
      // If coach not found or any error, redirect to profile completion
      // SECURITY: Log errors securely without exposing sensitive data
      console.warn('Coach profile validation failed - redirecting to completion');
      router.navigate(['/coach/profile-completion']);
      return of(false);
    })
  );
};